//idioma portugues brasil
//locale portugues brasil
module.exports = {
  "general.days": "dias",
  "general.day": "Dia",
  "general.select-days": "Selecionar dias",
  "general.select-day": "Selecionar dia",
  "general.selected-days": "Dias selecionados",
  "general.selected-day": "Dia selecionado",
  "general.date": "Data",
  "general.country": "País",
  "general.continue": "Continuar",
  "Info": "Informações",
  "Request": "Solicitar",
  "Notifications": "Avisos",
  "Account": "Conta",
  "Hotel amenities and services": "Comodidades e serviços do hotel",
  "To be able to enjoy our hotel more, see here the communities that we have":
    "Para poder desfrutar mais do nosso hotel, veja aqui as comunidades que temos disponíveis",
  "Please check the rooms for room amenities as they may vary":
    "Por favor, consulte os quartos para conhecer as comodidades do quarto, pois podem variar",
  "In order to enjoy our hotel more, we have the following precautions against covid":
    "Para poder desfrutar mais do nosso hotel, contamos com as seguintes precauções contra covid",
  "ID Code": "Código de Segurança",
  "Validate Code": "Validar Código",
  "general.key_explanation": "Esta chave será fornecida pelo concierge",
  "general.reservation": "Reserva",
  "general.guest": "Hóspede",
  "general.guests": "Hóspedes",
  "general.guests.one": "1 Hóspede",
  "general.guests.other": "{0} Hóspedes",
  "general.single.beds.one": "1 Cama de solteiro",
  "general.single.beds.other": "{0} Camas de solteiro",
  "general.double.beds.one": "1 Cama de casal",
  "general.double.beds.other": "{0} Camas de casal",
  "general.guidelines": "Diretrizes Gerais",
  "general.interests": "Interesses",
  "general.interests_hostz": "Informações",
  "general.interests_offgrid": "Interesses",
  "general.payments": "Pagamentos",
  "general.summary": "Resumo",
  "general.summary_offgrid": "Visão Geral",
  "general.back": "Anterior",
  "general.buy": "Comprar",
  "general.next": "Próximo",
  "general.next_offgrid": "Próximo",
  "general.checkout": "CheckOut",
  "general.confirm": "Confirmar",
  "general.clear": "Limpar",
  "general.cancel": "Cancelar",
  "general.close": "Fechar",
  "general.save": "Salvar",
  "general.go-back": "Voltar",
  "general.stay": "Estadia",
  "general.identify-using-qr": "Identificar-me usando QR",
  "general.identify-using-code": "Identificar-me usando Código",
  "general.identify-welcome": "Bem-vindo",
  "general.identify-welcome-phrase": "Por favor, prossiga para completar o pré-check-in e teremos tudo pronto para sua chegada.",
  "general.identify-welcome-phrase-offgrid": "Por favor, complete seu check-in online o mais rápido possível. Você receberá as informações de chegada um dia antes de sua chegada.",

  "general.identify-screen.title": "Entre no seu assistente digital para a estadia:",
  "general.identify-screen.subtitle": "Com seu código de reserva ou seus dados se já está no hotel",
  "general.identify-screen.subtitle-1": "Complete os dados para continuar",
  "general.identify-screen.button-code": "Tenho código de reserva",
  "general.identify-screen.button-data": "Estou hospedado",
  "general.identify-screen.button-identify": "Continuar",
  "general.identify-screen.button-return-code": "Ir para identificação por código de reserva",
  "general.identify-screen.button-return-data": "Ir para identificação com dados da reserva",
  "general.identify-screen.error-code": "Não conseguimos encontrar o código de reserva indicado, por favor, tente novamente!",
  "general.identify-screen.error-data": "Não conseguimos encontrar a reserva com os dados indicados, por favor, tente novamente!",
  "general.identify-screen.title-hostz": "Faça login agora e acesse o portal de hóspedes:",
  "general.active": "Ativo",
  "general.inactive": "Inativo",
  "general.go-to-detail": "Ir ao Detalhe",
  "general.go_to_website": "Conhecer mais",
  "general.go-to-my-stay": "Ir para Minha Estadia",
  "general.price": "Preço",
  "general.report": "Reportar",
  "general.edit": "Modificar",
  "general.checkin_edit": "Editar dados do Check-in",
  "general.experiences": "Experiências",
  "general.request": "Solicitar",
  "general.send": "Enviar",
  "general.detail": "Detalhe",
  "general.no-charge": "Grátis",
  "general.yes": "SIM",
  "general.no": "NÃO",
  "general.dateformat": "dd-MM-yyyy",
  "general.short-dateformat": "dd-MM",
  "general.chat": "Chat",
  "general.services": "Serviços",
  "general.equipment": "Equipamentos",
  "general.features": "Características",
  "general.from": "De",
  "general.to": "Até",
  "general.duration": "Duração",
  "general.today": "Hoje",
  "general.yesterday": "Ontem",
  "general.tomorrow": "Amanhã",
  "general.remove": "Remover",
  "general.upload": "Enviar",
  "general.upload-file": "Enviar Arquivo",
  "general.balance": "Saldo",
  "general.send_comment": "Enviar Comentário",
  "general.menu": "Cardápios",
  "general.start.checkin": "Começar Check-in",
  "general.placeOrder": "Fazer Pedido",
  "general.updateOrder": "Atualizar Pedido",
  "general.please": "Por favor",
  "general.touch": "Por favor, selecione a opção ",
  "general.total": "Total",
  "general.hour": "Hora",
  "general.time": "Hora",
  "general.qty": "Qtd.",
  "general.reserve": "Reservar",
  "general.selected": "Selecionado",
  "general.time-format": " hs",
  "general.select-date": "Por favor, selecione a data, hora e quantidade de pessoas para sua reserva",
  "general.no-schedule-available": "Não há horário disponível",
  "general.fields_required": "são campos obrigatórios",
  "general.about": "Sobre",
  "general.type_message": "Digite sua mensagem...",
  "general.items.qty": "Qtd. Itens",
  "general.notifications": "Notificações",
  "general.notifications_description": "Suas configurações pessoais nesta aplicação para personalizar sua experiência.",
  "general.add-to-home-screen-text": "Você pode adicionar esta página à sua tela inicial para acessar rapidamente.",
  "general.add-to-home-screen-button": "Adicionar à tela inicial",
  "general.hs": "hs.",
  "general.hs-abrev": "hs.",
  "general.min": "min.",
  "general.select_option": "Selecione uma opção...",
  "general.customization": "Configure seu add-on...",

  "hotel.website": "Site Web",
  "hotel.phones": "Telefones",
  "hotel.address": "Endereço",
  "hotel.contact-us": "Entre em contato conosco",
  "hotel.social-networks": "Redes Sociais",
  "hotel.please-feel": "Você pode se comunicar conosco sempre que desejar.",
  "hotel.conditioning-air-in-common-spaces":
    "Ar condicionado em espaços comuns",
  "hotel.location": "Localização",
  "hotel.parking": "Estacionamento",
  "hotel.free-parking": "Estacionamento gratuito",
  "hotel.pay-parking": "Estacionamento pago",
  "hotel.bar": "Bar",
  "hotel.aesthetic-center": "Centro de estética",
  "hotel.kids-club": "Clube para crianças",
  "hotel.luggage-storage": "Guarda-volumes",
  "hotel.breakfast": "Café da manhã",
  "hotel.breakfast-buffet": "Café da manhã buffet",
  "hotel.smoke-free-space": "Espaço livre de fumo",
  "hotel.fitness-center": "Academia",
  "hotel.gay-friendly": "Gay Friendly",
  "hotel.hydromassage": "Hidromassagem",
  "hotel.gardens": "Jardins",
  "hotel.masseuse-available": "Massagista disponível",
  "hotel.water-park": "Parque aquático",
  "hotel.hairdressing": "Cabeleireiro",
  "hotel.bilingual-staff-english-spanish": "Equipe bilíngue (Inglês/Espanhol)",
  "hotel.pet-friendly": "Pet Friendly",
  "hotel.pool": "Piscina",
  "hotel.smoking-points": "Pontos para fumantes",
  "hotel.reception-24-hs": "Recepção 24hs",
  "hotel.restaurant": "Restaurante",
  "hotel.restaurant-to-the-card": "Restaurante à la carte",
  "hotel.theme-restaurant": "Restaurante temático",
  "hotel.congress-hall": "Salão de congressos",
  "hotel.meeting-room": "Sala de reuniões",
  "hotel.sauna": "Sauna",
  "hotel.laundry-service": "Serviço de Lavanderia",
  "hotel.babycare-service": "Serviço de Creche",
  "hotel.spa": "Spa",
  "hotel.theater": "Teatro",
  "hotel.terraces": "Terraços",
  "hotel.souvenir-shop": "Loja de lembranças",
  "hotel.airport-transfer": "Transfer para o Aeroporto sob demanda",
  "hotel.covid.protected-medical-area": "Área médica protegida",
  "hotel.covid.virtual-check-in-out": "Check in / out virtual",
  "hotel.covid.temperature-check": "Verificação de temperatura",
  "hotel.covid.first-aid-kit-available": "Kit de primeiros socorros disponível",
  "hotel.covid.separation-screens-for-personnel":
    "Divisórias de separação para pessoal",
  "hotel.covid.contactless-payment-available": "Pagamento sem contato disponível",
  "hotel.covid.sanitizers-in-common-areas": "Sanitizantes em áreas comuns",
  "hotel.covid.use-of-specific-cleaning-articles-for-covid":
    "Uso de artigos de limpeza específicos para Covid",
  "meeting_rooms.dvd-player": "Reprodutor de DVD",
  "meeting_rooms.high-speed-wi-fi": "WIFI de alta velocidade",
  "meeting_rooms.independent-access": "Acesso Independente",
  "meeting_rooms.lunch-service": "Serviço de Almoço",
  "meeting_rooms.meeting-room": "Sala de Reunião",
  "meeting_rooms.megaphone": "Megafone",
  "meeting_rooms.microphone": "Microfone",
  "meeting_rooms.smart-tv": "Smart TV",
  "meeting_rooms.video-projection": "Projetor de Vídeo",
  "meeting_rooms.capacity": "Capacidade:",
  "meeting_rooms.people": "pessoas.",
  "room-categories.air-conditioning": "Ar condicionado",
  "room-categories.complimentary-dressing": "Guarda-roupa de cortesia",
  "room-categories.work-area": "Área de trabalho",
  "room-categories.private-balcony": "Varanda privada",
  "room-categories.cable": "Cabo",
  "room-categories.safe-box": "Cofre",
  "room-categories.sommier-beds": "Camas box",
  "room-categories.room": "Quarto",
  "room-categories.hydromassage": "Hidromassagem",
  "room-categories.coffee-machine": "Máquina de café",
  "room-categories.minibar": "Minibar",
  "room-categories.hairdryer": "Secador de cabelo",
  "room-categories.selection-of-pillows": "Seleção de travesseiros",
  "room-categories.ironing-service": "Serviço de passadoria",
  "room-categories.smart-tv": "Smart TV",
  "room-categories.king-size-bed": "Cama king size",
  "room-categories.phone": "Telefone",
  "room-categories.tv-lcd": "TV LCD",
  "room-categories.satellite-tv": "TV via satélite",
  "room-categories.street-view": "Vista para a rua",
  "room-categories.garden-view": "Vista para o jardim",
  "room-categories.sea-view": "Vista para o mar",
  "room-categories.wifi": "Wifi",
  "room-categories.ketle": "Chaleira elétrica",
  "room-categories.fridge": "Geladeira",
  "room-categories.dishwasher": "Lava-louças",
  "room-categories.oven": "Forno",
  "room-categories.freezer": "Congelador",
  "room-categories.water-heater": "Aquecedor de água",
  "room-categories.plates-glasses": "Pratos e copos",
  "room-categories.cutlery-dishes": "Talheres e pratos",
  "room-categories.microwave": "Micro-ondas",
  "room-categories.kettle": "Chaleira elétrica",
  "room-categories.nespresso-machine": "Máquina Nespresso",

  "room-categories.toilette-with-shower-box": "Toalete de Recepção com box de ducha",
  "room-categories.sofa-bed": "Sofá-cama",
  "room-categories.partial-sea-view": "Vista parcial para o mar",
  "room-categories.welcome-amenities": "Amenidades de boas-vindas",
  "room-categories.shower": "Chuveiro",
  "room-categories.bathtub": "Banheira",
  "room-categories.double-sink": "Dupla pia",
  "room-categories.connected-rooms": "Conectados",
  "room-categories.king-or-twin-beds": "Cama King ou 2 camas de solteiro",
  "room-categories.los-troncos-view": "Vista para o bairro Los Troncos",
  "room-categories.daily-courtesy-water": "Águas diárias de cortesia",
  "room-categories.daily-courtesy-capsule-dilmah": "Cortesia diária de cápsula ou infusão Dilmah",
  "room-categories.stay-courtesy-capsule-dilmah": "Cortesia de cápsula ou infusão Dilmah por estadia",

  "here": "aqui",
  "checkin.checkin.preparing-title": "Preparando seu Check-in",
  "checkin.checkin.preparing-text": "Por favor, não feche ou atualize esta janela.",
  "checkin.status": "Status do Check-in",
  "checkin.status-pending": "Pendente",
  "checkin.status-observed": "Observado",
  "checkin.status-to_validate": "Para Validar",

  "checkin.status-to_validate-text--":
    "<b>Isso é tudo por enquanto!</b> Revisaremos as informações e enviaremos uma notificação de confirmação. Muito obrigado!",
  "checkin.status-to_validate-text": "<b>Isso é tudo por enquanto!</b> Obrigado por completar o web check-in. Saudações cordiais",

  "checkin.status-in_progress": "Em Processo",
  "checkin.status-accepted": "Aceito",
  "checkin.status-accepted-text":
    "<b>Seu Check-in foi realizado com sucesso!</b> Estaremos esperando por você! Tenha uma boa viagem!",
  "checkin.status-no_show": "No Show",
  "checkin.status-no_show-text":
    "Use o chat abaixo caso deseje reagendar sua reserva original. Esperamos tê-lo conosco em breve!",
  "checkin.status-canceled": "Cancelado",
  "checkin.status-canceled-text":
    "Sua reserva foi cancelada! Entre em contato conosco usando o botão de chat abaixo se acredita que se trata de um erro ou se deseja modificar sua reserva. Obrigado!",
  "checkin.status-done": "Checked Out",
  "checkin.status-done-text":
    "Sua estadia foi completada! Entre em contato conosco usando o botão de chat abaixo. Obrigado!",

  "checkin.please-complete":
    "Por favor, complete as informações solicitadas e evite esperas no momento de ingressar. Se já tem um check-in carregado pode se identificar",
  "checkin.not-forget":
    "Não esqueça que se viaja com mais pessoas deverá inserir também seus dados para completar o check in.",
  "checkin.initiated": "Meu Check-in",
  "checkin.stay": "Estadia",
  "checkin.in": "Data de Entrada",
  "checkin.out": "Data de Saída",
  "checkin.travel-type": "Tipo de Viagem",
  "checkin.request-photos":
    "Certifique-se de que as imagens estejam focadas e legíveis. Você pode recortar e redimensionar as imagens após tirá-las.",
  "checkin.inputs.select": "Selecione...",
  "checkin.inputs.dni-number": "Número",
  "checkin.inputs.dni-number-offgrid": "Número",
  "checkin.inputs.email": "Email",
  "checkin.inputs.travelType": "Tipo de Viagem",
  "checkin.inputs.dni-issue-date": "Data de Emissão",
  "checkin.inputs.dni-issue-date-offgrid": "Data de Emissão",
  "checkin.inputs.dni-issue-date-simplex": "Data de Emissão",
  "checkin.inputs.dniIssueDate": "Data de Emissão",
  "checkin.inputs.dniIssueDate-offgrid": "Data de Emissão",
  "checkin.inputs.dniIssueDate-simplex": "Data de Emissão",
  "checkin.inputs.name": "Nome",
  "checkin.inputs.surname": "Sobrenome",
  "checkin.inputs.gender": "Gênero...",
  "checkin.inputs.gender.male": "Masculino",
  "checkin.inputs.gender.female": "Feminino",
  "checkin.inputs.gender.other": "Outro",
  "checkin.inputs.date-of-birth": "Data de Nasc.",
  "checkin.inputs.address": "Endereço",
  "checkin.inputs.postal-code": "CEP",
  "checkin.inputs.nationality": "Nacionalidade",
  "checkin.inputs.residence": "Residência",
  "checkin.inputs.country_of_residence": "País de Residência",
  "checkin.inputs.city": "Cidade",
  "checkin.inputs.dniType": "Tipo de ID",
  "checkin.inputs.zipCode": "Código postal",
  "checkin.inputs.dni": "Número de ID",
  "checkin.inputs.birthday": "Data de Nasc.",
  "checkin.inputs.phone": "Telefone",
  "checkin.inputs.passenger": "Dados do passageiro",
  "checkin.inputs.photos_dniFront": "Frente DOC",
  "checkin.inputs.photos_dniBack": "Verso DOC",
  "checkin.inputs.photos_selfie": "Selfie",

  "checkin.identificate": "Identificar-me",

  "checkin.passenger": "Viajante",
  "checkin.passengers": "Viajantes",
  "checkin.passengers-list": "Lista de Viajantes",
  "checkin.passengers-error-incomplete":
    "Deve completar os dados do viajante",
  "checkin.arrivalMode": "Modo de chegada",
  "checkin.arrivalMode-hostz": "Como chegará?",
  "checkin.arrivalMode-text": "Por favor, selecione o modo de chegada",
  "checkin.arrivalMode.airplane": "Avião",
  "checkin.arrivalMode.public_transportation": "Transporte público (ônibus/trem)",
  "checkin.arrivalMode.train": "Trem",
  "checkin.arrivalMode.bus": "Ônibus",
  "checkin.arrivalMode.car": "Carro",
  "checkin.arrivalMode.other": "Outro",
  "checkin.add-passenger": "Adicionar passageiro",
  "checkin.reservation-data": "Dados da Reserva",
  "checkin.reviewing":
    "Em breve receberá uma notificação sobre o <b>status de sua solicitação</b>. Lembre-se de que ainda pode modificar as informações inseridas.",
  "checkin.remember-can": "---",
  "checkin.can-see": "---",
  "checkin.please-read-to-change":
    "Por favor, revise a observação detalhada abaixo e realize as alterações solicitadas.",
  "checkin.modify": "Modificar",
  "checkin.edit-data": "Editar Dados",
  "checkin.accept": "Aceitar",
  "checkin.save-checkin": "Salvar Check-In",
  "checkin.save-changes": "Salvar Alterações",
  "checkin.update-info": "Atualizar Informações",
  "checkin.dni-front": "Frente DOC",
  "checkin.dni-back": "Verso DOC",
  "checkin.camera": "Câmera",
  "checkin.date-of-birth": "Data de Nasc.",
  "checkin.age": "Idade",
  "checkin.add-comment": "Adicionar comentário",
  "checkin.me": "Eu",
  "checkin.new-checkin": "Novo Check-In",
  "checkin.accepted-text":
    "<b>Seu Check-In foi realizado satisfatoriamente!</b> Estaremos esperando com tudo preparado para que possa ingressar sem esperas!",
  "checkin.canceled-text":
    "<b>Seu Check-In foi cancelado.</b> Por favor, leia os comentários abaixo para saber como proceder. Muito obrigado!",
  "checkin.use-button-to-add-guest":
    "Use o botão abaixo para adicionar outros viajantes.",
  "checkin.identified": "Check-In Identificado!",
  "checkin.identify-error":
    "Não conseguimos encontrar o código de reserva indicado, por favor, tente novamente!",
  "checkin.time-of-arrival": "Hora de Chegada",
  "checkin.time-of-arrival-text":
    "Se já tem uma hora estimada de chegada, nos informe aqui. Estaremos esperando por você!",
  "checkin.time-of-arrival-text2": "Seu apartamento está disponível a partir das {0} horas.",
  "checkin.time-of-arrival-text2-hostz": "Seu apartamento está disponível a partir das {0} horas.",
  "checkin.time-of-arrival-text2-offgrid": "Seu quarto está disponível a partir das {0} horas.",
  "checkin.time-of-arrival-early-checkin":
    "Solicitar <b>Early Check-In</b> <span class='text-muted'>(sujeito à disponibilidade)</span>",
  "checkin.e-mail": "E-Mail",
  "checkin.phone": "Telefone",
  "checkin.guest-data": "Dados dos Hóspedes",
  "checkin.guest-data-text":
    "Complete as informações que faltam para completar seu processo de registro online.",
  "checkin.guest-complete-later": "Completarei esta informação mais tarde.",
  "checkin.id-type.id": "RG",
  "checkin.id-type.passport": "PASSAPORTE",
  "checkin.id-type.nif": "NIF",
  "checkin.id-type.nie": "NIE",
  "checkin.type-of-travel": "Tipo de Viagem",
  "checkin.type-of-travel-text":
    "Personalizaremos sua experiência de acordo com suas preferências e necessidades.",
  "checkin.travel-type.couple": "Viagem a Dois",
  "checkin.travel-type.congress": "Congresso",
  "checkin.travel-type.family": "Viagem Familiar",
  "checkin.travel-type.business": "Viagem de Negócios",
  "checkin.travel-type.event": "Viagem para Evento",
  "checkin.travel-type.friends": "Viagem com Amigos",
  "checkin.travel-type.relaxing": "Viagem de relaxamento",
  "checkin.travel-type.party": "Viagem de Festa",
  "checkin.travel-type.single_traveler": "Viagem Individual",
  "checkin.travel-type.leisure": "Viagem de lazer",
  "checkin.redirecting": "Redirecionando em {0} segundos...",
  "checkin.room-preferences": "Preferência de Quarto",
  "checkin.room-preferences-text":
    "Tem alguma preferência para seu quarto? <br />Nos informe aqui:",
  "checkin.room-preferences.close-to-elevator": "Perto do elevador",
  "checkin.room-preferences.far-from-elevator": "Longe do elevador",
  "checkin.room-preferences.wheelchair-accessible":
    "Acessível para cadeirantes",
  "checkin.room-preferences.lower-floor": "Quarto em andar baixo",
  "checkin.room-preferences.higher-floor": "Quarto em andar alto",
  "checkin.take-care-environment":
    "Quer ajudar a cuidar do meio ambiente?",
  "checkin.take-care-environment-text":
    "Pequenas coisas podem reduzir significativamente sua pegada ambiental durante sua estadia.",
  "checkin.take-care-environment.housekeeping-frequency":
    "Frequência de Limpeza",
  "checkin.take-care-environment.housekeeping-frequency.everyday": "Todos os dias",
  "checkin.take-care-environment.housekeeping-frequency.every-other-day":
    "Dia sim, dia não",
  "checkin.take-care-environment.housekeeping-frequency.do-not-clean-my-room":
    "Não limpar meu quarto",
  "checkin.take-care-environment.towell-replacement-frequency":
    "Frequência de troca de toalhas",
  "checkin.take-care-environment.towell-replacement-frequency.do-not-change":
    "Não trocar toalhas",
  "checkin.take-care-environment.towell-replacement-frequency.everyday":
    "Todos os dias",
  "checkin.take-care-environment.towell-replacement-frequency.every-other-day":
    "Dia sim, dia não",
  "checkin.restaurant-reservation":
    "Estou interessado em fazer uma reserva em seu/s <b>restaurante/s</b>",
  "checkin.comments": "Comentários",
  "checkin.comments-text":
    "Nos informe se há algo que possamos fazer para melhorar sua estadia conosco.",
  "checkin.review-the-summary":
    "Revise o resumo de seu Check-In online. Pode voltar e editar qualquer informação que acabou de fornecer. Se tudo estiver correto, pressione o botão <b>\"Confirmar\"</b> abaixo.",
  "checkin.reservation-code": "Código de Reserva",
  "checkin.in-out": "Entrada / Saída",
  "checkin.primary-guest": "Hóspede Titular",
  "checkin.guests-text": "Precisamos desta informação para determinar a melhor configuração de camas para sua estadia e garantir seu conforto.<br /><br /><small>Adultos (15+ anos) / Crianças (3-14 anos) / Bebês (0-2 anos)</small>",
  "checkin.adult-s": "Adulto(s)",
  "checkin.adults": "Adultos",
  "checkin.adult": "Adulto",
  "checkin.short-room": "Quarto",
  "checkin.room": "Quarto",
  "checkin.do-not-disturb": "Não Perturbe",
  "checkin.select-door-open": "Por favor, selecione a porta que deseja abrir...",
  "checkin.select-door-open-hostz": "Clique na porta que deseja abrir",
  "checkin.select-door-open-themyde": "Selecione a porta que deseja abrir e deslize o botão",
  "checkin.select-photo-source-to": "Selecione a origem para ",
  "checkin.use-camera": "Usar Câmera",
  "checkin.selfie.preview-title": "Foto Frontal",
  "checkin.selfie.preview-text": "Recorte a imagem para centralizar bem seu rosto.",
  "checkin.dniFront.preview-title": "Frente RG",
  "checkin.dniFront.preview-text": "Recorte a imagem para centralizar bem seu documento.",
  "checkin.dniBack.preview-title": "Verso RG",
  "checkin.dniBack.preview-text": "Recorte a imagem para centralizar bem seu documento.",
  "checkin.camera.repeat": "Repetir",
  "checkin.camera.crop": "Recortar",
  "checkin.camera.use-photo": "Usar Foto",
  "checkin.sign-and-confirm": "Assinar & Confirmar",
  "checkin.gdpr-text1": "Ao assinar abaixo, dou meu consentimento para o processamento de meus dados pessoais de acordo com a",
  "checkin.gdpr-text2": ". Entendo que posso retirar meu consentimento a qualquer momento.",
  "checkin.gdpr-text-nexo": "e o",

  "checkin.gdpr-text1-costa": "Ao assinar abaixo, autorizo o tratamento de meus dados pessoais conforme a",
  "checkin.gdpr-text2-costa": ", e declaro não ser residente fiscal na República Argentina segundo a",
  "checkin.gdpr-text-nexo-costa": ", com a possibilidade de retirar meu consentimento a qualquer momento. Assim, confirmo ter lido e aceitar o ",
  "checkin.gdpr-text3-costa": "Declaro que minha estadia na Argentina é por turismo e não excede o prazo permitido por lei, com fins de reembolso de IVA pela lei N° 3971(AFIP) e a Resolução N° 566.",
  "checkin.gdpr-button-2-popup": "Declaro que minha estadia na República Argentina não excede o prazo máximo que estabelece a legislação migratória vigente e que minha estadia no país é por turismo.<br />Sirva a presente Declaração Jurada para os efeitos de realizar a tramitação de solicitação de reembolso do imposto sobre o valor agregado conforme Resolução Geral N° 3971(AFIP) e Resolução N° 566(Turismo)",

  "checkin.gdpr-text1-hostz": "Ao assinar abaixo, dou meu consentimento para o tratamento de meus dados pessoais de acordo com a",
  "checkin.gdpr-text2-hostz": ".",
  "checkin.gdpr-text-nexo-hostz": " e entendo que posso retirar meu consentimento a qualquer momento.<br/><br/>Reconheço e aceito cumprir com os ",

  "checkin.gdpr-text1-simplex": "Ao assinar abaixo, dou meu consentimento para o tratamento de meus dados pessoais de acordo com a",
  "checkin.gdpr-text2-simplex": ".",
  "checkin.gdpr-text-nexo-simplex": " e entendo que posso retirar meu consentimento a qualquer momento.<br/><br/>Reconheço e aceito cumprir com os ",

  "checkin.gdpr-text1-offgrid": "Ao assinar abaixo, aceito o tratamento e uso de meus dados pessoais de acordo com o",
  "checkin.gdpr-text2-offgrid": " da Offgrid Mindful Cabins.",
  "checkin.gdpr-text-nexo-offgrid": " e aceito os ",

  "checkin.gdpr-button": "Política de Privacidade",
  "checkin.gdpr-button-1": "Regulamento do Hotel",
  "checkin.gdpr-button-1-simplex": "Regulamento do Hotel",
  "checkin.gdpr-button-1-hostz": "Regulamento do Hotel",
  "checkin.gdpr-button-1-hostz-swissstay": "Regulamento",
  "checkin.gdpr-button-1-offgrid": "Termos e Condições Gerais",
  "checkin.gdpr-button-2": "Resolução Geral N° 3971 (AFIP)",

  "checkin.terms-and-conditions": "Termos e Condições",
  "checkin.hotel-regulations": "Regulamento do Hotel",

  "checkin.terms-and-conditions-button-detail": "da estadia no Hotel",
  "checkin.the_myde_selfie_message": "Por favor, envie um <b>selfie de você segurando seu documento de identidade</b> (passaporte, carteira de identidade ou carteira de motorista). Isso nos ajuda a manter sua estadia segura e sem complicações.",
  "checkin.reservation-conditions-text": "A administração não se responsabiliza pelos objetos de valor que sejam deixados no quarto.<br /><br /><b>O horário de saída é até as 11:00 do meio-dia.</b><br /><br /><span class='text -danger font-weight-bold'>Não é permitido fumar em todos os nossos quartos nem em todas as áreas públicas.</span><br />Só é permitido fumar fora do edifício, na rua. Se ainda fumar no quarto, cobraremos uma taxa de limpeza de 250,00 euros.<br /><br /><small>Os dados mencionados anteriormente são gerenciados pela EDP.</small>",
  "checkin.reservation-conditions-text-offgrid": "<b>Check-in:</b> a partir das 15:00<br/><b>Check-out:</b> até as 11:00<br/><ul><li>É proibido fumar em todas as nossas cabanas.</li><li>Por favor, tenha em mente que apenas os hóspedes registrados podem permanecer e pernoitar na cabana. O número máximo de hóspedes é de 2 pessoas.</li><li>Por favor, informe danos e defeitos imediatamente através de Relatório de danos em seu guia ou entre em contato conosco através de nossa linha direta: +49 30 54806375.</li><li>Viagem e uso de nossos alojamentos off-grid são por sua conta e risco; não aceitamos responsabilidade por restrições relacionadas ao clima, condições das estradas ou acidentes. Regulamentos detalhados podem ser encontrados em nossos termos e condições.</li></ul><br/>Um resumo das regras da cabana está em seu guia de viagem em Sua cabana -> Regras da cabana.",
  "checkin.signature": "Assinatura",
  "checkin.please-sign-here": "Toque para assinar",
  "checkin.please-sign-below": "Por favor assine abaixo",
  "checkin.confirm": "Confirmar",
  "checkin.newsletter": "Newsletter",
  "checkin.newsletter-optin": "Gostaria de receber novidades e ofertas do hotel por email",
  "checkin.click-edit-data-text1": " para realizar as modificações necessárias. Uma vez que tenha feito as alterações, pressione ",
  "checkin.click-edit-data-text2": " e depois ",
  "checkin.click-edit-data-text3": ". Agradecemos sua colaboração!",

  "checkin.floor-selection": "Seleção de Andar",
  "checkin.floor-selection-text": "Por favor, selecione o andar em que deseja se hospedar. Lembre-se, não dispomos de elevadores.",
  "checkin.ground-floor": "Térreo",
  "checkin.first-floor": "Primeiro Andar",
  "checkin.indifferent": "Indiferente",
  "checkin.entry-time-not-know-yet": "Ainda não sei",
  "checkin.child": "Criança",
  "checkin.child-s": "Criança(s)",
  "checkin.children": "Crianças",
  "checkin.no-children": "Sem Crianças",
  "checkin.babies": "Bebês",
  "checkin.years": "anos",

  "checkin.dniFront.required": "Frente DOC Obrigatório",
  "checkin.selfie.required": "Selfie Obrigatória",
  "checkin.dniBack.required": "Verso DOC Obrigatório",
  "checkin.the_myde_selfie_message_title": "Importante!",
  "checkin.please-complete-your-checkin-title": "Check-in Pendente",
  "checkin.please-complete-your-checkin-text": "Por favor, complete seu check-in clicando aqui.",
  "checkin.no.name.yet": "Nome não fornecido ainda",

  "cups.title": "Add-ons",
  "cups.remove_button": "Remover",
  "cups.add_button": "Adicionar",
  "cups.subject_to_availability": "Sujeito à disponibilidade",
  "cups.subject_to_availability_text": "Este item está sujeito à disponibilidade. Durante este processo, não serão incorridos custos, e ao selecioná-lo, um representante do hotel entrará em contato com você para fornecer mais detalhes sobre isso.",
  "cups.preferedList_text": "Baseado em seus interesses, temos essas experiências para você",
  "cups.otherList_text": "Talvez essas experiências também te interessem",
  "cups.tags.best-selling": "Mais vendido",
  "cups.tags.most-popular": "Mais popular",
  "cups.tags.best-price": "Melhor preço",
  "cups.priceIsPerNight": "por noite",
  "cups.confirm": "Confirma esta compra?",
  "cups.booked": "Reservado",
  "cups.spots": "lugar(es)",

  "checkout.loading-information":
    "Por favor, aguarde enquanto recolho as informações de sua estadia.",
  "checkout.errors-title":
    "Não é possível realizar o Check-out neste momento.",
  "checkout.error-balance":
    "Sua conta tem um saldo em aberto de {0}. Por favor cancele seu saldo para continuar.",
  "checkout.error-departure":
    "A data de Check out é no dia {0}. Deseja modificar sua data de saída?",
  "checkout.button": "Prosseguir com o CheckOut",
  "checkout.error-departure-button": "Precisa de ajuda? Chateie conosco!",
  "date.january": "Janeiro",
  "date.february": "Fevereiro",
  "date.march": "Março",
  "date.april": "Abril",
  "date.may": "Maio",
  "date.june": "Junho",
  "date.july": "Julho",
  "date.august": "Agosto",
  "date.september": "Setembro",
  "date.october": "Outubro",
  "date.november": "Novembro",
  "date.december": "Dezembro",
  "checkout.success-title": "Seu CheckOut foi bem-sucedido!",
  "checkout.error-noShowBalance": "Se tem alguma pergunta em relação aos custos ou precisa de assistência, estamos aqui para ajudá-lo! Simplesmente clique no botão de chat que encontrará abaixo. Além disso, se deseja cancelar sua conta, pode fazê-lo diretamente desta seção. Sua satisfação é nossa prioridade",
  "checkout.debt": "Não podemos processar o checkout. Sua estadia tem um saldo em aberto de: ",
  "checkout.pay_now": "Pagar agora",
  "checkout.ask_for_balance": "Infelizmente, não podemos processar o checkout neste momento. Por favor, chateie conosco para obter instruções adicionais.",
  "maps.how_to_reach_us": "Como chegar até nós?",
  "maps.get_directions": "Como chegar",
  "welcome.title": "Bem-vindo ao nosso hotel!",
  "welcome.subtitle": "Desejamos que tenha uma excelente estadia!",
  "welcome.text":
    "<b>Meu nome é ViCo e serei seu concierge virtual!</b> Estou disponível para você 24hs por dia e pode me pedir o que precisar! Para isso entre na seção Solicitar de onde poderá pedir room service, solicitar a limpeza do quarto, reposição de suprimentos, etc.",
  "welcome.text-costa-galana":
    "<b>Com nosso serviço Mobile Concierge</b>, receba um atendimento personalizado 24 horas para atender suas preferências, solicitações e recomendações... <br /><br />Do conforto de seu dispositivo, solicite serviço de governança, room service, reservas de restaurantes e spa. <br /><br />Clique em 'Começar' e entre na seção Solicitar.<br /><br />Se desejar pode se comunicar da extensão 99 de seu quarto.",


  "welcome.text-belair": "<b>Bem-vindo ao Grand Brizo Bel Air!</b><br /><br />Através deste canal de comunicação estaremos disponíveis 24 horas para assisti-lo com qualquer necessidade que possa surgir.<br /><br />Pode entrar na seção <b>Solicitar</b>, onde encontrará opções para pedir room service, reservar serviços do hotel, solicitar limpeza de quarto, entre muitas outras comodidades pensadas para você.",
  "welcome.text-hostz-becozy": "Bem-vindo ao nosso Becozy Basel, você encontrará tudo que precisa para aproveitar ao máximo sua estadia.<br><br>Através deste portal, você pode elevar sua experiência com nossos serviços disponíveis, explorar nossa propriedade, descobrir coisas para fazer na área, e muito mais.",
  "welcome.text-hostz-san-carlo": "Bem-vindo ao nosso Hotel San Carlo em Lugano, você encontrará tudo que precisa para aproveitar ao máximo sua estadia.<br><br>Através deste portal, você pode elevar sua experiência com nossos serviços disponíveis, explorar nossa propriedade, descobrir coisas para fazer na área, e muito mais.",
  "welcome.text-hostz-blacksummit": "Bem-vindo ao Black Summit Resort em Laax! Neste portal, você encontrará tudo que precisa para aproveitar ao máximo sua estadia.<br><br>Através deste portal, você pode elevar sua experiência com nossos serviços disponíveis, explorar nossa propriedade, descobrir coisas para fazer na área, e muito mais.",
  "welcome.text-hostz-betahouse": "Bem-vindo! Você está agora registrado.",
  "welcome.text-hostz-themyde": "<br/><br/><b>Bem-vindo! Você já está registrado. </b>Encontre todos os seus dados de acesso na seção de Informações de acesso no seu Painel de controle.<br/><br/></br/>",
  "welcome.text-hostz-arosa": "<br/><br/><b>Bem-vindo! Você já está registrado. </b>Encontre todos os seus dados de acesso na seção de Informações de acesso no seu Painel de controle.<br/><br/></br/>",
  "welcome.text-hostz-swissstay": "Bem-vindo! Você está agora registrado. Agora pode encontrar todas as suas instruções de acesso na seção de Informações de Acesso do seu painel.",
  "welcome.text-hostz-steiners": "Bem-vindo! Você está agora registrado. Agora pode encontrar todas as suas instruções de acesso na seção de Informações de Acesso do seu painel.",

  "welcome.subtitle-offgrid": "Bem-vindo ao seu Guia da Cabana :)",
  "welcome.text-offgrid": "Aqui você encontrará tudo que precisa para sua estadia, desde seu <b>check-in online</b> e <b>informações de chegada</b> até dicas úteis para seu tempo na cabana.<br><br>Se tiver alguma pergunta, não hesite em nos contatar a qualquer momento, estamos felizes em ajudá-lo!<br>Para assuntos urgentes, simplesmente nos envie uma mensagem pelo <b>WhatsApp +49 30 54806375</b>.",
  "welcome.footer-offgrid": "👉 <b>Para fácil acesso</b>, você pode salvar o Guia da Cabana na sua tela inicial. Simplesmente toque <b>aceitar</b> e arraste o ícone para onde quiser. Não ocupa espaço e pode removê-lo a qualquer momento após sua estadia.<br><br><b>Que tenha uma estadia maravilhosa!</b> 🌿",
  "welcome.footer-belair": "Para facilitar ainda mais o acesso, recomendamos criar um atalho na tela inicial do seu telefone. Não ocupa espaço e pode removê-lo facilmente ao finalizar sua estadia.<br /><br />Estamos à sua disposição para garantir que tenha uma estadia agradável.<br /><br /><b>Equipe Grand Brizo Bel Air</b>",
  "welcome.room-offgrid": "Cabana",

  "welcome.footer-hostz": "Para facilitar o acesso, recomendamos habilitar as notificações e criar um atalho na sua tela inicial. Isso ajudará você a se manter atualizado com informações importantes sobre sua estadia e permitirá realizar solicitações facilmente para que sua estadia seja ainda mais confortável.",
  "welcome.footer-hostz-betahouse": "Agora você pode encontrar todas as suas instruções de acesso na seção de Informações de Acesso do seu painel.",

  "welcome.room": "Seu quarto é:",
  "welcome.room_bs": "Seu apartamento é:",
  "welcome.footer":
    "Para me encontrar mais facilmente, por favor aceite criar um atalho na tela inicial do seu telefone. Não ocupa espaço e pode removê-lo assim que sair do hotel.<br /><br /><b>Será um prazer atendê-lo!</b>",
  "welcome.start": "Começar",
  "services.type.general": "Consultas",
  "services.type.room_service": "Serviço de Quarto",
  "services.type.pool_service": "Serviço de Piscina",
  "services.type.room_supplies": "Suprimentos de Quarto",
  "services.type.laundry": "Lavanderia",
  "services.type.porter": "Porteiro",
  "services.type.tray_collection": "Coleta de Bandeja",
  "services.type.pressing": "Passadoria",
  "services.type.housekeeping": "Limpeza de Quarto",
  "services.type.wakeup_call": "Chamada Despertador",
  "services.type.car_valet": "Valet Parking",
  "services.type.concierge": "Concierge",
  "services.type.lost_objects": "Objetos Perdidos",
  "services.type.breakage_report": "Relatório de Danos",
  "services.type.services_booking": "Reserva de Serviços",
  "services.type.review_tracking": "Ticket de acompanhamento sobre sua avaliação",
  "services.type.up_selling": "Add-On",
  "services.type.items_sales": "Produtos",
  "services.type.gift_store": "Loja de Presentes",
  "services.housekeeping.horary":
    "Lembre-se de que o horário para solicitar a limpeza de quarto é das 7 às 14hs. Caso contrário, seu quarto não será limpo.",
  "services.housekeeping.horary-costa-galana":
    "Lembre-se de que o horário para solicitar a limpeza de quarto é das 7 às 17hs.",
  "services.housekeeping.do-not-clean-today": "Não limpar o quarto hoje",
  "services.housekeeping.do-not-change-towels": "Não trocar toalhas hoje",
  "services.housekeeping.button-title": "Enviar solicitação",
  "services.donotdisturb.button-title-activate":
    "Ativar modo <b>NÃO PERTURBE</b>",
  "services.donotdisturb.button-title-disable":
    "Desativar modo <b>NÃO PERTURBE</b>",
  "services.donotdisturb.extra-info":
    "Enquanto mantiver o estado ativo de <b>\"NÃO PERTURBE\"</b> não será possível fazer a limpeza nem responder a suas solicitações.",
  "services.do-not-change-towels": "Não trocar as toalhas",
  "services.sent-text":
    "<b>Solicitação Enviada!</b> Assim que for processada será notificado, também pode fazer acompanhamento desde sua tela de <b>Painel de Controle</b>. ",
  "services.go-to-requests": "Minha estadia",
  "services.go-to-home": "Ir para Início",
  "services.status.pending": "Pendente",
  "services.status.observed": "Observado",
  "services.status.accepted": "Aceito",
  "services.status.in_progress": "Em Processo",
  "services.status.in_transit": "Em Trânsito",
  "services.status.done": "Completo",
  "services.status.canceled": "Cancelado",
  "services.status.on_hold": "Pendente",
  "services.status.seated": "Ingressado",
  "services.status.confirmed": "Confirmado",
  "services.active-request": "Há {0} solicitação ativa!",
  "services.active-requests": "Há {0} solicitações ativas!",
  "select...": "Selecione...",
  "services.confirm-request": "Seu pedido está completo?",

  "smartlocks.swipe-to-open": "DESLIZAR PARA ABRIR",
  "smartlocks.pin-code-arosa-explanation": "Depois de inserir o PIN CODE, você deve pressionar os botões # ou ↵ (enter) para confirmar.",
  "status.messages": "Você tem mensagens!",
  "status.no_messages": "Ainda não respondemos à sua consulta sobre este assunto. Entraremos em contato com você em breve.",
  "status.more": "Mais sobre sua estadia",
  "status.faqs": "Perguntas Frequentes",
  "status.faqs_description": "Toda a informação em um só lugar",
  "status.contact": "Entre em contato",
  "status.contact_whatsapp": "Nos envie um WhatsApp",
  "status.contact_description": "Estamos aqui para ajudá-lo!",
  "status.settings.btnDescription_facilities_arosa":"Grandes ofertas de nossos parceiros",
  "status.checkin_alert": "Há novidades no seu Check-in",
  "status.checkin_alert_offgrid": "Neuigkeiten zu deinem Check-in",
  "status.checkin_edit": "Modificar informações de check in",
  "status.checkout_description": "Registrar sua saída",
  "status.stay_description": "Informações sobre sua estadia",
  "status.stay.info": "Estadia",
  "status.checkin.chat": "Mensagens de Check-in",
  "status.checkin.chat-desc": "Mensagens durante seu processo de check-in",
  "status.settings": "Avisos",
  "status.settings_description": "Habilitar avisos e notificações",
  "status.wifi": "WiFi",
  "status.wifi_description": "Acesso ao WiFi",
  "status.wifi_name": "Nome da rede",
  "status.wifi_password": "Senha",
  "status.wifi_no_password": "Nenhuma (rede aberta)",
  "status.garbage": "Instruções para eliminação de lixo",
  "status.parking_info": "Instruções de estacionamento",
  "status.garbage_description": "Tudo que você precisa saber",
  "status.extra-bed": "Instruções cama extra",
  "status.extra-bed_description": "Veja como preparar sua cama extra.",
  "status.parking_info_description": "Tudo que você precisa saber",
  "status.access_code": "Códigos de acesso",
  "status.room_access_code": "Códigos de acesso ao quarto",
  "status.room_keys": "Chaves do quarto",
  "status.room_keys_description": "Pode recolhê-las nas caixas de chaves localizadas no hall",
  "status.room_keys_description_becozy": "Pode recolhê-las nas caixas de chaves localizadas na porta do quarto",
  "status.room_keycard": "Cartão chave do quarto",
  "status.room_keycard_description": "Apenas recolha na recepção",
  "status.apartment_keys": "Chaves do apartamento",
  "status.apartment_keys_description": "Simplesmente recolha suas chaves na caixa de chaves na entrada principal",
  "status.access_code_one": "Código de acesso",
  "status.access_code.pin_code": "Código PIN",
  "status.access_code_hostz": "Códigos de acesso aos apartamentos",
  "status.access_information": "Informações de acesso",
  "status.access_information_extramsg_steiners": "A recepção está aberta todos os dias entre {0} e {1} e está localizada após a porta de entrada principal, à esquerda",
  "status.access_information_description": "Tudo que você precisa para acessar a propriedade",
  "status.access_code_description": "Informações de acesso",
  "status.access_code.main_entrance": "Porta de entrada",
  "status.access_code.main_door": "Código de acesso da entrada principal",
  "status.access_code.room_door": "Código da caixa de segurança do quarto",
  "status.access_code.ladder": "Código da escada",

  "status.access_information.access_to_room_themyde": "Acesso ao seu apartamento",
  "status.access_code.ladder_themyde": "Porta de entrada principal / Código da escada",

  "status.access_information.access_to_hotel": "Acesso ao hotel",
  "status.access_information.accesses_swissstay": "Acessos",
  "status.access_information.access_to_room": "Acesso ao seu quarto",

  "status.access_code.main_entrance_themyde": "PORTAS E ENTRADAS",
  "status.access_information.access_to_room_cover": "Durante a estadia você encontrará aqui as instruções para obter as chaves de acesso",
  "status.access_information.access_to_room_cover_arosa": "Disponível às 16hs",
  "status.access_information.access_to_room_cover_sigma": "Disponível às 16hs",
  "status.access_information.access_to_room_description_cozy": "Obtenha seu cartão de acesso das caixas verdes (Keynest) no lobby.",
  "status.access_information.main_entrance_description_steiners": "A porta está aberta durante o dia. <br>Se estiver fechada, por favor use o código abaixo para abrir a CAIXA DE CHAVES N.1 e utilize o cartão digital dentro para abrir a porta principal.",
  "status.access_information.access_to_room_description_steiners": "Consiga seu cartão-chave das caixas de chaves verdes localizadas no 2º andar.",

  "status.access_instructions": "Instruções de acesso",
  "status.access_instructions_description": "Seu procedimento de acesso",
  "status.access_code.key_collection_code": "Código de coleta de chaves",
  "status.access_code.key_dropoff_code": "Código de devolução de chaves",
  "status.access_code.key_dropoff": "Devolução de chaves",
  "status.access_code.key_dropoff_instructions": "Deixe a chave na caixa preta ao lado da caixa verde onde você recolheu as chaves.",  
  "status.access_code.key_card_collection_code": "Código de coleta de cartão",
  "status.access_code.key_card_dropoff_code": "Código de devolução de cartão",

  "status.access_information.before_checkin": "Os dados de acesso estarão disponíveis no dia do check-in.",
  "status.access_information.before_checkin_with_hours": "O código da porta principal do hotel estará visível a partir das {0} do dia do check-in. Os detalhes do seu quarto (número e código da caixa de chaves) estarão disponíveis a partir das {1} do mesmo dia.",
  "status.access_information.before_checkin_with_hours_themyde": "Você poderá ver suas informações de acesso às {0} (hora do check-in)",
  "status.access_information.before_checkin_with_hours_cozy": "As informações de acesso estarão disponíveis no dia do check-in às {0}, apenas se o formulário de check-in foi completado e o pagamento foi realizado (incluindo o depósito de segurança de {1}).",
  "status.access_information.before_checkin_with_hours_steiners": "As informações de acesso estarão disponíveis no dia do check-in às {0}, apenas se o formulário de check-in foi completado e o pagamento foi realizado (incluindo o depósito de segurança de {1}). Se acabou de pagar a reserva e a hora de registro já passou, por favor, aguarde de 3 a 5 minutos para que a transação seja processada, e uma vez aprovada, as informações estarão visíveis.",
  "status.access_information.before_checkin_with_hours_no_sd": "As informações de acesso estarão disponíveis no dia do check-in às {0}, apenas se o formulário de check-in foi completado e o pagamento foi realizado.",
  "status.access_information.before_checkin_main": "Damos as boas-vindas a partir das {0} da manhã para que desfrute das instalações do hotel. Também pode deixar sua bagagem na área de guarda-volumes enquanto espera que seu quarto esteja pronto às {1}. Os detalhes do seu quarto serão compartilhados às {1}.",
  "status.access_information.before_checkin_room": "O código da porta principal do hotel estará visível a partir das {0} do dia do check-in. Os detalhes do seu quarto (número e código da caixa de chaves) estarão disponíveis a partir das {1} do mesmo dia.",
  "status.access_information.after_checkin": "Sua estadia foi finalizada e os dados de acesso não estão mais disponíveis. Obrigado por nos visitar! Esperamos dar as boas-vindas novamente em breve.",
  "status.access_information.main_entrance": "Entrada principal",
  "status.access_information.main_entrance_code": "Código da entrada principal",
  "status.access_information.main_entrance_code_sigma": "Código da entrada principal & Código da entrada traseira",
  "status.access_information.main_entrance_code_swissstay": "Acesso principal",
  "status.access_information.main_entrance_code_and_skiroom_code": "Código da entrada principal & Código da sala de esquí",
  "status.access_information.room_keybox_code": "Código da caixa de chaves (localizada junto à porta do seu quarto)",
  "status.access_information.room_keybox_code_arosa": "Código da caixa de chaves (a caixa de chaves está localizada NA PORTA DO SEU QUARTO)",
  "status.access_information.please_use_main_key": "Por favor, use a CHAVE PRINCIPAL",
  "status.access_information.link_modal_video": "Assista a este breve vídeo para ver como funciona o check-in",
  "status.access_information.link_modal_video_themyde": "Assista a este breve vídeo para ver como funciona o check-in",
  "status.access_information.title_modal_video": "Como usar",
  "status.access_information.room_lock_box_code": "Código da caixa de chaves",
  "status.access_information.room_lock_box_location": "Localização da caixa de chaves",

  "status.location": "Localização",
  "status.location_description": "Obtenha direções para chegar à propriedade.",
  "status.location_description_swissstay": "Obtenha direções para chegar ao apartamento aqui.",
  "status.parking": "Estacionamento",
  "status.parking_description": "Acesso e regras",

  "bookable.limit": "Reservar antes de ",

  "account.add-device": "Adicionar Disp.",
  "account.stay": "Estadia",
  "account.room": "Quarto",
  "account.more-info": "Mais Info",
  "account.guest": "Hóspede",
  "account.charges": "Custos",
  "account.payments": "Pagamentos",
  "account.accommodation": "Estadia",
  "account.accommodation_description": "Noite de estadia",
  "account.citytax": "Imposto municipal",
  "account.foodandbeverages": "Comida & Bebidas",
  "account.foodandbeverages_description":
    "Consumos no bar, restaurante, etc.",
  "account.other": "Outros Custos",
  "account.other_description": "Outros custos associados à estadia",
  "account.download": "Baixar",
  "account.invoices": "Faturas",
  "account.balance": "Saldo",
  "account.chat": "Se tiver perguntas sobre a fatura, não hesite em nos contatar.",


  "review.rate": "Sua avaliação é:",
  "review.rate_us": "Avalie-nos",
  "review.thanks": "Obrigado por sua avaliação!",
  "review.extra_rate": "Avaliações Adicionais",
  "review.extra_rate_text": "Essas avaliações nos ajudam a melhorar nosso serviço",
  "review.sending_response": "Enviando resposta…",
  "review.rate-placeholder": "Escreva seu comentário aqui...",
  "review.already-rated": "Obrigado por nos avaliar, sua opinião é muito valiosa",
  "review.already-rated-button": "Gostaria de mudar minha avaliação.",
  "review.average": "Média",
  "review.general": "Geral:",
  "review.contact": "Por favor, gostaríamos que nos deixe seu contato para podermos responder sobre sua avaliação.",
  "review.screen_title": "Avaliação",
  "review.flow_type_rating": "Avaliação",
  "review.flow_type_single_choice": "Escolha única",
  "review.flow_type_opinion_scale": "Escala de opinião",
  "review.flow_type_ranking": "Ranking",
  "review.flow_type_landing": "Landing",

  "request.detail-title": "Detalhe da Solicitação",
  "request.delivery-point": "Ponto de Entrega",
  "request.your-request": "Seu Pedido",
  "request.customize_next": "Personalize na próxima tela",
  "request.continue_customize": "Continuar e Personalizar",
  "request.products_not_available": "Produtos não disponíveis neste horário",
  "request.product_not_available": "Produto não disponível neste horário",
  "request.available-time": "Produto disponível nos horários",
  "request.item-out-of-hours": "Produto não disponível neste horário",
  "request.available-time-from-to": "{0} às {1}hs",
  "request.product": "Produto",
  "request.products": "Produtos",
  "request.creating-order": "Criando pedido",
  "request.creating-order-title": "Estamos criando seu pedido",
  "request.creating-order-description": "Estamos enviando seu pedido ao hotel. Isso leva apenas alguns segundos.",
  "request.order-created": "Pedido criado",
  "request.order-created-title": "Pedido criado com sucesso",
  "request.order-created-description": "Seu pedido ja foi registrado. Em instantes voce sera levado ao detalhe para acompanha-lo.",
  "request.redirecting-to-order": "Redirecionando para o detalhe em",
  "request.view-order-now": "Ver pedido agora",
  "request.status-pending": "Pendente",
  "request.confirm-cancel": "Tem certeza de que deseja cancelar seu pedido?",
  "request.only-one-for-type":
    "Você só pode ter uma solicitação aberta deste tipo!",
  "request.lost_objects.observation":
    "Descreva aqui os objetos que você perdeu em detalhes e quando e onde poderia tê-los perdido",
  "request.generic.observation": "Se desejar deixe um comentário aqui",
  "request.general.observation": "Por favor, nos diga como podemos ajudá-lo hoje!",
  "request.car_valet.observation": "Nos informe como podemos ajudá-lo com seu veículo...",
  "request.tray_collection.observation": "Alguma instrução especial para a coleta?",
  "request.breakage_report.observation": "Por favor, nos informe o que está quebrado ou não funciona corretamente",
  "request.housekeeping.observation": "Por favor, nos informe se tem algum requisito especial aqui",
  "request.feedback.feedback": "Por favor, nos conte em que podemos melhorar...",


  "request.option": "Opção",
  "request.observations": "Comentários",
  "request.observations-placeholder": "Escreva suas observações, tentaremos seguir à risca",
  "request.create.comment": "Deixar um comentário sobre seu pedido",
  "request.reserved-days": "Dias Reservados",

  "notifications.enable": "Habilitar Notificações",
  "notifications.not_now": "Agora não",
  "notifications.accept":
    "<b>Importante:</b> Habilite as notificações para que possa receber atualizações em tempo real do status de suas solicitações.",
  "notifications.accepted":
    "<b class=\"text-success\">Notificações Ativadas!</b> A partir de agora receberá notificações em tempo real de seu processo de Check-in e de suas solicitações durante a estadia.",
  "notifications.blocked":
    "<b class=\"text-danger\">Notificações Bloqueadas!</b> Permita as notificações para que possamos enviar notificações importantes sobre o status de suas solicitações! Clique no ícone de cadeado na barra de endereços do seu navegador e ative as notificações. Obrigado.",
  "notifications.confirm-continue":
    "<b>Tem certeza de que quer continuar?</b> As notificações melhorarão sua experiência enquanto nos visita.",
  "notifications.empty-title": "Você não tem Notificações",
  "notifications.empty-text":
    "Quando receber uma notificação ela será exibida aqui.",
  "notificacions.title": "Notificações",
  "notifications.link.make-the-review": "Fazer Avaliação",


  "stay.add-device-use-qr":
    "Use o QR de outro dispositivo para adicioná-lo à estadia.",


  "yup.required": "O campo é obrigatório",
  "yup.only-letters": "Apenas letras são permitidas",
  "yup.only-numbers": "Apenas números são permitidos",
  "yup.only-numbers-and-letters": "Apenas números ou letras",
  "yup.minimal-6-digits": "Deve conter no mínimo 6 dígitos",
  "yup.minimal-7-digits": "Deve conter no mínimo 7 dígitos",
  "yup.minimal-2-letters": "Deve conter no mínimo 2 letras",
  "yup.maximal-50-letters": "Deve conter no máximo 50 letras",
  "yup.maximal-12-digits": "Deve conter no máximo 12 dígitos",
  "yup.maximal-25-digits": "Deve conter mais de 25 dígitos",
  "yup.wrong-date": "Data Inválida",
  "yup.please-review": "Por favor, revise este valor",
  "yup.email-invalid-format": "Formato incorreto de e-mail",

  "toast.do-not-disturb-mode-active-title": "Modo \"Não Perturbe\" ativo",
  "toast.do-not-disturb-mode-active-text":
    "Para poder fazer um pedido deve desativar o modo NÃO PERTURBE!",
  "toast.do-not-disturb-mode-active-link": "Desativar",

  "payments.summary-of-charges": "Resumo de Cargos",
  "payments.guarantee-deposit-paid": "Sua reserva já tem um depósito de garantia ativo.",
  "payments.balance-paid": "Sua reserva não tem saldo pendente de pagamento.",
  "payments.total-to-pay": "Total a pagar",
  "payments.pay": "Ir para pagar",
  "payments.retry-pay": "Tentar pagamento novamente",
  "payments.items-pay-with-deposit": "A seguir estão listados os custos a pagar:",
  "payments.guarantee-deposit": "Depósito de segurança",
  "payments.guarantee-deposit-desc": "Este valor ficará retido mas não será cobrado em seu cartão de crédito.",
  "payments.select-items-pay": "Selecione os itens que deseja pagar",
  "payments.payment-ok": "Seu pagamento foi realizado corretamente",
  "payments.payment-error": "Ocorreu um erro ao tentar realizar o pagamento",
  "payments.payment-not-authorised": "Pagamento não autorizado",
  "payments.pending-confirmation": "Estamos confirmando seu pagamento com o banco. Não feche esta tela.",
  "payments.pending-timeout": "A confirmação do pagamento está demorando mais que o habitual. Tente novamente ou fale com a recepção.",
  "payments.payment-unavailable-continue": "Pagamento indisponível no momento, você pode continuar com o web check-in e pagar depois.",
  "payments.loading-component": "Carregando componente de pagamento...",
  "payments.later": "Vou pagar depois",
  "payments.confirm-pay-later": "Você confirmará o pedido e pagará depois. Use o botão Comprar abaixo.",
  "payments.back-to-pay-later": "escolher pagar depois",
  "payments.msg_guarantee": "No Black Summit Laax, solicitamos um depósito de segurança para garantir uma estadia segura e agradável para todos os nossos hóspedes. Este depósito atua como medida de precaução para cobrir possíveis danos à propriedade, móveis ou comodidades, bem como custos imprevistos, como limpeza adicional ou saídas tardias. O depósito será liberado 7 dias após a saída, uma vez que a propriedade tenha sido inspecionada e não tenham sido encontrados problemas. O reembolso será processado em seu método de pagamento original.",
  "payments.msg_guarantee_72hs": "Lembre-se de que deverá pagar um depósito de {0} CHF como medida obrigatória 72 horas antes de sua chegada. Receberá uma notificação por e-mail como lembrete.",
  "payments.older": "Pagamento anterior",

  "facilities.Carta_Belleza": "Carta de Beleza",
  "spa.Carta_Tratamientos": "Cardápio de Massagens",
  "facilities.Carta_SPA": "Cardápio",
  "home.chat-24-7": "Chat 24/7",
  "home.book-a-room": "Reservar um quarto",
  "home.book-an-apartment": "Reservar um apartamento",

  "door.main": "Principal",
  "door.back": "Traseira",
  "room.address": "Endereço",
  "room.number": "Número do quarto",
  "room.floor": "Andar do quarto",
  "apartment.address": "Endereço do apartamento",
  "apartment.number": "Apartamento",
  "apartment.floor": "Andar do apartamento",

  "public.bookable.init": "Por favor, selecione a quantidade de pessoas e a data que deseja consultar disponibilidade",
  "public.bookable.sent-text": "<b>Solicitação Enviada!</b> <br/>Assim que for processada será notificado do status de sua reserva.",
  "public.bookable.fill-data": "Por favor, complete os seguintes dados para finalizar sua reserva do dia:",
  "public.edit-hour": "Modificar horário",
  "public.input.name-and-surname": "Nome e Sobrenome",
  "public.input.phone": "Telefone",
  "public.input.email": "Email",
  "public.input.observations": "Comentários",
  "public.bookable.gala-experience": "Have you attended a Hotel Gala before?",
  "public.bookable.gala-experience.required": "Please select an option",
  "public.input.location": "Localização",
  "public.input.location.arena": "Sombrilla arena",
  "public.input.location.piscina": "Sombrilla piscina",
  "public.input.location.carpa": "Carpa",
  "public.input.tent": "Número de carpa",
  "public.bookable.list-empty": "Não existem serviços disponíveis para fazer reservas.",
  "general.processing-request": "Processando solicitação...",
  "public.dashboard.home": "Início",
  "public.dashboard.services": "Serviços",
  "public.dashboard.my-profile": "Meu perfil",
  "complete-to-web-checkin": "Web Check-In",
  "public.request.status.canceled-msg": "A solicitação foi cancelada.",
  "services.make-your-reservation": "Faça sua reserva",  
  "services.make-your-reservation-button": "Reserve nossos serviços",
  "public.personal-information": "Informações pessoais",
  "public.input.number": "Número",
  "services.type.beach_service": "Serviço de praia",
  "service.type.request": "Solicitação",
  "public.request.payment-status.not-captured": "O pagamento não pôde ser capturado. Por favor, tente novamente para poder finalizar sua solicitação.",
  "public.request.payment-status.pay-again": "Reintentar pago",

  "public.reservation.not-found": "Não foi encontrado o detalhe da reserva",
  "public.reservation.welcome": "Olá {0}, estes são os dados da sua reserva:",
  "public.reservation.date-and-hour": "Data e hora",
  "public.reservation.people": "Pessoas",
  "public.reservation.adults": "Adultos",
  "public.reservation.adult": "Adulto",
  "public.reservation.children": "Crianças",
  "public.reservation.child": "Criança",
  "public.reservation.state": "Estado",
  "public.reservation.observations": "Observações",
  "public.dashboard.logout": "Terminar sessão",
  "public.dashboard.welcome": "Bem-vindo, {0}!",
  "public.dashboard.no-reservations": "Você não tem reservas ativas",
  "public.request.cancel-assistance": "Cancelar assistência",
  "public.request.cancel-request": "Cancelar", 
  "public.reservation.status.remember-status": "Aceito",
  "public.reservation.view-reservations": "Ver todas as minhas reservas",
  "public.reservation.confirm": "Confirmar",
  "public.reservation.confirm_msg": "Você poderá confirmar sua reserva até 72hs antes do horário de início.",
  "public.reservation.status.validating": "Processando solicitação",
  "public.request.status.validating-msg": "Sua solicitação está sendo processada, nós iremos notificá-lo quando estiver pronto.",
  "public.reservation.confirmated-at": "Reserva confirmada em",
  "public.request.forbidden.title": "Esta solicitação não pode ser exibida",
  "public.request.forbidden.desc": "Esta solicitação não corresponde ao usuário atual.<br/>Por favor, certifique-se de estar acessando com o usuário correto.<br/>Se você acredita que isso é um erro, entre em contato com o suporte.",
  "public.request.forbidden.button": "Ir para o dashboard",
  "public.dashboard.not-found": "Não foi encontrado o perfil do usuário",
  "public.dashboard.my-data": "Meus dados",
  "public.dashboard.name": "Nome completo",
  "public.dashboard.email": "Email",
  "public.dashboard.phone": "Telefone",
  "public.dashboard.my-reservations": "Minhas reservas",
  "public.dashboard.my-requests": "Minhas solicitações",
  "public.dashboard.requests": "Solicitações",
  "public.reservation.status.confirmed": "Confirmado",
  "public.request.not-found": "Detalhes da solicitação não encontrados",
  "public.request.welcome": "Olá {0}, aqui estão os detalhes da sua solicitação:",
  "public.request.date-and-hour": "Data e hora",
  "public.request.people": "Pessoas",
  "public.request.passengers": "Passageiros",
  "public.request.title": "Detalhes da solicitação",
  "public.request.state": "Status",
  "public.request.observations": "Observações",
  "public.request.additional-observations": "Observações adicionais",
  "public.request.view-requests": "Ver todas as minhas solicitações",
  "public.request.confirm-assistance": "Confirmar assistência",
  "public.reservation.status.accepted": "Validando solicitação",
  "public.reservation.status.canceled": "Cancelado",
  "public.reservation.status.pending": "Requer confirmação",
  "public.reservation.status.confirmed": "Confirmado",
  "public.request.confirmed": "Solicitação confirmada em",
  "public.dashboard.go-to-my-reservations": "Ir para minhas reservas",
  "public.dashboard.cgbeach.public_cart": "Fazer pedido",
  "menu.all": "Todos",
  "menu.search": "Buscar no cardápio...",
  "menu.search_room_service": "Buscar produto...",
  "menu.search_restaurant": "Buscar no Restaurante...",
  "menu.category": "Categoria {0}",
  "menu.vegetarian": "Vegetariano",
  "menu.gluten_free": "Sem Glúten",
  "menu.items_not_found": "Não há itens configurados para este serviço. Consulte com o administrador.",
  "menu.fail_laod_items": "Erro ao carregar os itens do serviço. Tente novamente mais tarde.",
  "menu.price_without_taxes": "Preço sem impostos nacionais:",
  "no-hours.disabled.day": "Este serviço não estará disponível durante o dia de hoje.",
  "no-hours.disabled.general": "Esta seção está fechada para o horário atual",
  "no-hours.disabled.slot": "Este serviço não está disponível no momento. Por favor, tente novamente mais tarde.",
  "checkin.company-information": "Informações da Empresa",
  "checkin.company-information-text": "Por favor, forneça as informações da sua empresa.",
  "checkin.company-name": "Nome",
  "checkin.company-name-placeholder": "Digite o nome",
  "checkin.company-address": "Endereço",
  "checkin.company-address-placeholder": "Digite o endereço",
  "checkin.company-country": "País",
  "checkin.company-country-placeholder": "Selecione o país",
  "checkin.company-zip-code": "Código Postal",
  "checkin.company-zip-code-placeholder": "Digite o código postal",
  "checkin.company-city": "Cidade",
  "checkin.company-city-placeholder": "Digite a cidade",
  "general.invalid-dates": "Não há tarifas disponíveis para períodos superiores a {0} dias.", 
  "general.selected-days": "Dias selecionados",
  "general.selected-day": "Dia selecionado",
  "general.day": "Dia",
  "general.no-rates-available-for-selected-dates": "Não há tarifas disponíveis para os dias selecionados.",
  "general.must-select-passengers": "Selecione quantidade e passageiros em pelo menos uma categoria de passageiros.",
  "general.payment-method": "Método de pagamento",
  "general.select-passengers": "Selecionar passageiros",
  "general.select-passenger": "Selecionar passageiro",

  "days.sunday": "Domingo",
  "days.monday": "Segunda-feira",
  "days.tuesday": "Terça-feira",
  "days.wednesday": "Quarta-feira",
  "days.thursday": "Quinta-feira",
  "days.friday": "Sexta-feira",
  "days.saturday": "Sábado",

  "public_cart.hours-label": "Horário de atendimento",
  "public_cart.no-available-hours": "Nenhum horário disponível",

  "kiosk.welcome.subtitle": "Check-in concluído com sucesso",
  "kiosk.room": "Quarto",
  "kiosk.checkin": "Check-in",
  "kiosk.checkout": "Check-out",
  "kiosk.download_app": "Escaneie para acessar os serviços do hotel",
  "kiosk.scan_qr": "Escaneie o código QR para acessar serviços adicionais",
  "kiosk.generating_qr": "Gerando código QR...",
  "kiosk.redirect_warning": "Redirecionando você em {seconds} segundos...",
  "kiosk.go_to_identify": "Finalizar",
  "kiosk.logout.title": "Sair do modo Kiosk",
  "checkin.document-info": "Informações do Documento",
  "checkin.personal-info": "Informações Pessoais",
  "checkin.location": "Localização",
  "kiosk.back": "Voltar",
  "general.accept": "Aceitar",
  "CHECKINS_FOUND_NONE_VALID": "A reserva ainda não está disponível para check-in. Tente novamente na data de chegada",
  "CHECKINS_FOUND_MORE_THAN_ONE_VALID": "Houve um problema ao encontrar a reserva pelo quarto. Tente usar o código da reserva",
  "CHECKINS_FOUND_NONE_LASTNAME_VALID": "Não foi possível encontrar a reserva",
  "kiosk.login.title": "Digite seu PIN",
  "kiosk.login.description": "Por favor, digite o código de acesso para continuar",
  "kiosk.login.button_access": "Acessar",
  "kiosk.login.button_loading": "Carregando...",
  "kiosk.login.error_empty": "Por favor digite o PIN",
  "kiosk.login.error_invalid": "PIN inválido. Tente novamente.",
  "kiosk.login.error_process": "Erro ao processar o login. Tente novamente.",
  "kiosk.login.copyright": "© {year} {hotel}. Todos os direitos reservados.",
  "kiosk.login.subtitle": "Por favor, complete os seguintes dados para continuar",
  "kiosk.login.subtitle-2": "Por favor, complete os seguintes dados para continuar",
  "general.identify-screen.subtitle-2": "Por favor, complete os seguintes dados para continuar",
  "kiosk.login.pin": "Digite o PIN",
  "kiosk.logout.confirm": "Digite seu PIN para fazer logout do modo Kiosk",
  "kiosk.receiving-info": "Recebendo informações...",
  "kiosk.inactivity-warning-title": "Você ainda está aí?",
  "kiosk.inactivity-warning-message": "Você ficou inativo. Se não responder nos próximos segundos, sua sessão terminará automaticamente.",
  "kiosk.inactivity-countdown": "A sessão será fechada em",
  "kiosk.inactivity-stay": "Sim, continuar",
  "kiosk.inactivity-logout": "Não, sair"
};
